import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Checkbox from 'components/checkbox';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { MdContentCopy } from 'react-icons/md';

const SHOP_URL = 'https://shop.toola.fr';

const CommandPageInfo = (props: { user: any; handleChange: any }) => {
    const { user, handleChange } = props;
    const nav = useNavigate();
    const shopLink = user?.shopSlug ? `${SHOP_URL}/c/${user.shopSlug}` : '';

    const copyShopLink = () => {
        if (!shopLink) return;
        navigator.clipboard.writeText(shopLink);
        toast.success('Lien copié !');
    };

    return (
        <Card extra={'w-full mt-3 px-6 py-6 border'}>
            {/* Header */}
            <div className="w-full px-1">
                <h4 className="text-xl font-medium">Informations générales</h4>
            </div>
            {/* inputs */}
            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                <div className="col-span-2 rounded-lg bg-blue-50 border border-blue-200 p-3">
                    <p className="text-sm font-medium text-navy-700 dark:text-white">
                        Lien à mettre sur votre site internet
                    </p>
                    <p className="mt-1 text-xs text-gray-600">
                        Utilisez ce lien (et non le lien générique shop.toola.fr/command)
                        pour que les visiteurs de votre site soient bien rattachés à
                        votre boutique, notamment pour le bouton "Intéressé par le catalogue".
                    </p>
                    <div className="mt-2 flex items-center gap-2">
                        <code className="flex-1 truncate rounded-lg border border-gray-200 bg-white px-2.5 py-2 text-xs text-navy-700">
                            {shopLink || 'Génération du lien en cours...'}
                        </code>
                        <button
                            onClick={copyShopLink}
                            disabled={!shopLink}
                            className="flex items-center gap-1 rounded-lg bg-[#0260CB] px-3 py-2 text-xs font-medium text-white hover:bg-[#01499b] disabled:opacity-50"
                        >
                            <MdContentCopy size={14} />
                            Copier
                        </button>
                    </div>
                    <div className="mt-3">
                        <InputField
                            label="Personnaliser l'identifiant (optionnel)"
                            placeholder="votre-entreprise"
                            value={user?.shopSlug || ''}
                            id="shopSlug"
                            type="text"
                            onChange={(e: any) =>
                                handleChange({
                                    target: {
                                        id: 'shopSlug',
                                        value: e.target.value
                                            .toLowerCase()
                                            .replace(/[^a-z0-9-]+/g, '-'),
                                    },
                                })
                            }
                            inputSmall={true}
                        />
                    </div>
                </div>
                <div className="col-span-2">
                    <InputField
                        label="Informations de contact"
                        value={user?.contactInformation}
                        placeholder={
                            '+33 6 12 34 56 78 - contact@fournisseur.fr'
                        }
                        id="contactInformation"
                        type="text"
                        onChange={handleChange}
                        inputSmall={true}
                    />
                </div>
                <div className="col-span-2">
                    <InputField
                        label="Annonces (mise en avant via un pop-up)"
                        placeholder={'Aucune livraison possible le 25 décembre'}
                        value={user?.announcements}
                        id="announcements"
                        type="text"
                        onChange={handleChange}
                        inputSmall={true}
                    />
                </div>
                <div className="col-span-2 flex items-center gap-2 rounded-lg bg-yellow-50 p-3 border border-yellow-200">
                    <Checkbox
                        checked={!!user?.showProductDetailsOnShop}
                        onChange={(e: any) =>
                            handleChange({
                                target: {
                                    id: 'showProductDetailsOnShop',
                                    value: e.target.checked,
                                },
                            })
                        }
                    />
                    <div className="flex-1">
                        <p className="text-sm font-medium text-navy-700 dark:text-white">
                            Afficher les détails produit (variété, producteur, calibre, origine...) sur la boutique
                        </p>
                        <p className="text-xs text-gray-600 mt-1">
                            Désactivé par défaut. Activez pour afficher ce bloc sur vos fiches produit dès qu'un champ est renseigné.
                        </p>
                    </div>
                </div>
                <div className="col-span-2 flex items-center gap-2 rounded-lg bg-yellow-50 p-3 border border-yellow-200">
                    <Checkbox
                        checked={!!user?.restrictManualOrdersToShopVisibility}
                        onChange={(e: any) =>
                            handleChange({
                                target: {
                                    id: 'restrictManualOrdersToShopVisibility',
                                    value: e.target.checked,
                                },
                            })
                        }
                    />
                    <div className="flex-1">
                        <p className="text-sm font-medium text-navy-700 dark:text-white">
                            Limiter les commandes manuelles aux produits visibles sur la boutique B2B
                        </p>
                        <p className="text-xs text-gray-600 mt-1">
                            Désactivé par défaut. Activez pour qu'un produit masqué de la boutique B2B n'apparaisse plus non plus dans la création de commande manuelle.
                        </p>
                    </div>
                </div>
                {/* Card and button to handle my product visible or not per default */}
                <div
                    className="mt-1 col-span-2 bg-toola-500/20 shadow-sm rounded-lg p-2 hover:border hover:cursor-pointer"
                    onClick={() => nav('/b2b-display-global')}
                >
                    <h4 className="text-sm font-medium">
                        Gérer la visibilité de mes produits
                    </h4>
                    <p className="mt-1 text-xs">
                        Vous pouvez choisir de cacher ou non vos produits par
                        défaut
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default CommandPageInfo;
